// extracted by mini-css-extract-plugin
module.exports = {"container":"UserControl_container__1WONA","allowButtonsContainer":"UserControl_allowButtonsContainer__1EaX9"};